

import {request} from '../http';
import domain from '../domain';

var ImService = function(){
    if(domain.env === 'online'){
        this.domain = "//imserv.51tiangou.com/publics";
    }else{
        this.domain = '//imserv.'+ domain.env + '.66buy.com.cn/publics';
    }
};

/**
 * 聊一聊
 * @param params
 */
ImService.prototype.getByMemberId  = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/tgou/easemob/getByMemberId", params);
};
/**
 * 获取用户还信信息
 */
ImService.prototype.getAccount  = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/tgou/easemob/getAccount", params);
};
/**
 * 获取用户还信信息
 */
ImService.prototype.getServiceNo  = function(params = {}){
	var that = this;
	params.type = 'POST';
	that._serviceAjaxCom("/tgou/easemob/kefu/serverNo", params);
};
/**
 * 获取技能组ID
 */
ImService.prototype.getSkillGroup  = function(params = {}){
    var that = this;
    params.type = 'POST';
    that._serviceAjaxCom("/tgou/easemob/getSkillGroup", params);
};
ImService.prototype._serviceAjaxCom = function(url,params){
    params.url = this.domain + url;
    request(params);
};

/**
 * 【web】通过counterId获取导购IM账号列表
 * 接口文档地址：//dev.51tiangou.com/interfaces/detail.html?id=106
 * @param   {Object}        params
 * @param   {object}        params.data
 * @param   {String|Number} params.data.counterId
 * @param   {String|Number} params.data.storeId
 * @param   {String}        [params.data.tgAppVersion]  app 版本号
 * @desc    counterId 和 storeId 必须传一个
 * 2017-10-18 接口切换
 * 由 publics/tgou/getByCounterId 切换到 publics/tgou/getUserList
 */
ImService.prototype.getServiceList = function ( params ) {
    return this._serviceAjaxCom("/tgou/getUserList", params);
};

export default new ImService();/**
 * Created by admin on 2016/10/24.
 */
